import React, { useState } from "react";
import Select from "react-select";
// import util from "../../Utils/mappers";
import reactSelectStyle from "./reactSelectStyle";

const naOption = {
  bls: "N/A",
  blsAreaCode: 0,
  blsAreaId: 0,
  label: "N/A",
  value: 0,
};

const CountyselectInput = (props) => {
  const {
    input,
    inputOnChange,
    passLabelBack,
    meta,
    formApi,
    formValues,
    schemaProps: {
      machine_name,
      disableWhenField,
      parent_machine_name,
      skipFirstReset,
      secondaryCounty,
      updateBls,
      updateBlsCode,
      clearSchema,
      restrictCountyOptions,
      stateField,
      naOptionWhen,
    },
    disabledOnEdit,
    fieldArrayExtraInfo,
    areaCountyOptions,
    counties,
    ...rest
  } = props;
  const [stateChanged, setStateChanged] = useState(false);

  let onlyOneCounty = false;
  const [disableFlag, setDisableFlag] = useState(false);
  const clearFields = () => {
    clearSchema.forEach((c) => {
      let fieldToClear = parent_machine_name
        ? `${parent_machine_name}[0]${c}`
        : c;
      formApi.change(fieldToClear, null);
    });
  };
  let county_options = [],
    lookup_state,
    lookup_state_addendum,
    OES_options;
  let disableField =
    rest && rest.tableName
      ? rest.tableName + disableWhenField
      : disableWhenField;

  if (Array.isArray(disableWhenField)) {
    disableField = disableWhenField[0].when;
  }
  if (
    formApi &&
    formApi.getFieldState(disableField) &&
    formApi.getFieldState(disableField).value !== undefined
  ) {
    lookup_state_addendum = formApi.getFieldState(disableField).value;
  }
  lookup_state = parent_machine_name
    ? formValues &&
      formValues[parent_machine_name] &&
      formValues[parent_machine_name][0] &&
      formValues[parent_machine_name][0][disableWhenField]
    : formValues[disableField];

  if (!!stateField) {
    lookup_state = formValues[stateField];
  }

  const [stateValue, setStateValue] = useState(lookup_state);
  const [skipReset, setSkipReset] = useState(skipFirstReset || false); // in cases where we want to skip the first reset (section F of 9035)\

  const machine_name_modified = parent_machine_name
    ? `${parent_machine_name}[0]${machine_name}`
    : machine_name;
  let options;
  const restrictCounties = (chosenMSATitle) => {
    let restrictedOptions = [];
    restrictedOptions =
      counties[stateValue]?.filter((county) => county.bls === chosenMSATitle) ??
      [];
    if (!!restrictedOptions.length) {
      options = restrictedOptions;
    }

    if (restrictedOptions.length === 1) {
      input.onChange(restrictedOptions[0]);
      onlyOneCounty = true;
    } else if (restrictedOptions.length !== 0 && stateChanged) {
      const countyExists = restrictedOptions.find(
        (county) => county.label === input.value.label
      );
      if (!countyExists) {
        input.onChange(null);
      } else {
        input.onChange(input.value);
      }
      onlyOneCounty = false;
      setStateChanged(false);
    }
  };
  const handleChange = (selectedOption) => {
    input.onChange(selectedOption);
    if (!!updateBlsCode && !!selectedOption.blsAreaCode) {
      formApi.change(updateBlsCode, selectedOption.blsAreaCode);
    }
    if (updateBls && selectedOption.bls) {
      let bls_machine_name_modified = parent_machine_name
        ? `${parent_machine_name}[0]${updateBls}`
        : updateBls;
      let bls_value_modified = selectedOption.bls;
      let bls_area_id = selectedOption.blsAreaId;
      // if option to clear a value is present clear it
      if (updateBls.hasOwnProperty("type")) {
        bls_machine_name_modified = parent_machine_name
          ? `${parent_machine_name}[0]${updateBls.machine_name}`
          : updateBls.machine_name;
        switch (updateBls.type) {
          case "select":
            bls_value_modified = {
              label: selectedOption.bls,
              value: selectedOption.bls,
            };
            break;
          default:
        }
      }
      formApi.change(bls_machine_name_modified, bls_value_modified);
      if (
        updateBls.hasOwnProperty("machine_name_id") &&
        updateBls.machine_name_id &&
        bls_area_id
      ) {
        let bls_machine_name_id_modified = parent_machine_name
          ? `${parent_machine_name}[0]${updateBls.machine_name_id}`
          : updateBls.machine_name_id;
        formApi.change(bls_machine_name_id_modified, bls_area_id);
      }
    }
    setSkipReset(false);
  };

  if (counties === false || !counties) {
    return (
      <div className="county-select-input">
        <Select
          {...input}
          id={machine_name}
          isDisabled={disableFlag}
          value={input.value}
          isSearchable={true}
          backspaceRemovesValue={true}
          placeholder="Type search term here"
          hideSelectedOptions={true}
          styles={reactSelectStyle}
        />
      </div>
    );
  }
  options = counties[stateValue];

  const shouldRestrict =
    typeof restrictCountyOptions === "function"
      ? restrictCountyOptions(formApi)
      : restrictCountyOptions;

  if (lookup_state) {
    if (counties && counties.length > 0) {
      setDisableFlag(false);
      options = counties[lookup_state];
    }

    // change state value if different from current value
    if (lookup_state && lookup_state !== stateValue && counties) {
      setStateValue(lookup_state);
      setStateChanged(true);
      setDisableFlag(false);

      // change the state? reset the county
      if (
        !skipReset &&
        !fieldArrayExtraInfo?.isInitialStateValue &&
        !!stateValue &&
        (lookup_state !== "- Select -" || lookup_state != undefined)
      ) {
        formApi.change(machine_name_modified, undefined);
        if (updateBls && !shouldRestrict) {
          let bls_machine_name = parent_machine_name
            ? `${parent_machine_name}[0]${updateBls}`
            : updateBls;
          if (updateBls.hasOwnProperty("type")) {
            bls_machine_name = parent_machine_name
              ? `${parent_machine_name}[0]${updateBls.machine_name}`
              : updateBls.machine_name;
          }
          formApi.change(bls_machine_name, undefined);
        }
        if (updateBlsCode && !shouldRestrict) {
          formApi.change(updateBlsCode, undefined);
        }
        if (
          !!naOptionWhen &&
          formApi.getState().values[naOptionWhen.when] !== naOptionWhen.is
        ) {
          input.onChange(undefined);
        }
      }

      if (options && options.length > 0) {
        options.sort(function (a, b) {
          if (a.label < b.label) {
            return -1;
          }
          if (a.label > b.label) {
            return 1;
          }
          return 0;
        });
      }
    }
  }
  let setDisabled;
  if (
    areaCountyOptions &&
    areaCountyOptions.areaOptions !== undefined &&
    areaCountyOptions.countyOptions !== undefined &&
    areaCountyOptions.areaOrCounty !== undefined &&
    areaCountyOptions.state !== undefined &&
    areaCountyOptions.state !== "- Select -" &&
    !areaCountyOptions.ignoreStates.includes(areaCountyOptions.state)
  ) {
    setDisabled = false;
    let select_options = areaCountyOptions[areaCountyOptions.areaOrCounty];
    OES_options = select_options;
    if (secondaryCounty) {
      OES_options = areaCountyOptions["secondaryCountyOptions"];
    }
  }
  // array of values to check to determine if field should be disabled

  if (disableWhenField && Array.isArray(disableWhenField)) {
    setDisabled = false;
    disableWhenField.forEach((f) => {
      let check_val = formValues[f.when];
      if (Array.isArray(f.is)) {
        f.is.forEach((fis) => {
          if (check_val === fis) {
            setDisabled = true;
          }
        });
      }
      if (typeof f.is === "string") {
        if (check_val === f.is) {
          setDisabled = true;
        }
      }
    });
  }

  if (!!disableWhenField && typeof disableWhenField === "function") {
    setDisabled = disableWhenField(formApi.getState().values);
  }

  if (
    !!naOptionWhen &&
    formApi.getState().values[naOptionWhen.when] === naOptionWhen.is
  ) {
    options = [naOption];
    input.onChange(naOption);
  }

  if (shouldRestrict) {
    restrictCounties(formApi.getState().values[updateBls]);
  }

  let isDisabled = setDisabled || disableFlag || disabledOnEdit;
  return (
    <div className="county-select-input">
      <Select
        {...input}
        className={machine_name}
        styles={reactSelectStyle}
        inputId={input.name}
        isDisabled={isDisabled || onlyOneCounty}
        options={options && options.length > 0 ? options : OES_options}
        onChange={(e) => {
          handleChange(e);
          clearSchema && clearFields();
          inputOnChange && inputOnChange(e.value);
          passLabelBack && passLabelBack(e);
        }}
        value={input.value}
        isSearchable={true}
        backspaceRemovesValue={true}
        placeholder="Type search term here"
        hideSelectedOptions={true}
      />
    </div>
  );
};

export default CountyselectInput;
